import { render } from "./ArrowLeft.vue?vue&type=template&id=6aa0f35e"
const script = {}

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__